import { roll } from './roll';

export const makeSex = (): Sex => {
  return roll(0.51) ? '♀' : '♂';
};
